import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { StyledInput2 } from "../../components/login/StyledInput";
import { useAuthContext } from "../../context/authContext";
import {
  setDocumentTitle,
  useSiteNameContext,
} from "../../context/siteNameContext";
import { Button } from "../../shared/button";
import { UserService } from "../../APIService/UserService";
import { TUserInfo } from "../../types";
import AdminService from "../../APIService/AdminService";
import Report83Table from "../../components/reportTables/Report83Table";
import { isAdmin, isTeacher } from "../../helpers/role";
import Loading from "../../shared/loading";

export function Report83Page() {
  const { siteNameList } = useSiteNameContext();
  setDocumentTitle(siteNameList, "report83");

  const { authInfo } = useAuthContext();
  const params = useParams();
  const id = params.id ? Number(params.id) : authInfo.id;
  const [days, setDays] = useState<number>(100000);
  const [daysToShow, setDaysToShow] = useState<number>(-1);
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const handleChange = (event: any) => {
    const { value } = event.target;
    setDaysToShow(value);
    // setError(value > 30 || value < 0);
  };

  const [userInfo, setUserInfo] = useState<TUserInfo>({} as TUserInfo);

  useEffect(() => {
    UserService.getUserInfo(id).then((user) => {
      setUserInfo(user);
    });
  }, []);

  const handleClick = () => {
    setDaysToShow(daysToShow);
    if (daysToShow == -1) setDays(100000);
    else setDays(daysToShow);
  };
  const handleClickToday = () => {
    setDaysToShow(0);
    setDays(0);
  };
  const handleClickYesterday = () => {
    setDaysToShow(1);
    setDays(1);
  };
  const handleClickWeek = () => {
    setDaysToShow(7);
    setDays(7);
  };
  const handleClickMonth = () => {
    setDaysToShow(30);
    setDays(30);
  };
  const handleClickYear = () => {
    setDaysToShow(365);
    setDays(365);
  };
  const handleClickAll = () => {
    setDaysToShow(-1);
    setDays(100000);
  };

  const [tableDataResult, setTableDataResult] = useState([]);

  useEffect(() => {
    AdminService.getReport83(id, days).then((result) => {
      setTableDataResult(result.data);
      setLoading(false);
    });
  }, [id, days]);

  return (
    <div className="Wrapper">
      <h2>
        Отчет 83. Сводка по домашним заданиям ученика {id}{" "}
        {isAdmin(authInfo.role) || isTeacher(authInfo.role)
          ? " (" + userInfo?.sysName + ")"
          : ""}
      </h2>

      <Grid item xs={12} sm={4} md={2}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <StyledInput2
            size="small"
            label={"Дни"}
            value={daysToShow}
            onChange={handleChange}
          />
          {error ? <p>{"Введите число большее 0"}</p> : <p></p>}
          <Button disabled={error} onClick={handleClickToday}>
            Сегодня
          </Button>
          <Button disabled={error} onClick={handleClickYesterday}>
            Вчера
          </Button>
          <Button disabled={error} onClick={handleClickWeek}>
            Неделя
          </Button>
          <Button disabled={error} onClick={handleClickMonth}>
            Месяц
          </Button>
          <Button disabled={error} onClick={handleClickYear}>
            Год
          </Button>
          <Button disabled={error} onClick={handleClickAll}>
            Все время
          </Button>
        </div>
        <Grid>
          <Button disabled={error} onClick={handleClick}>
            Обновить отчет
          </Button>
        </Grid>
      </Grid>
      <p />
      <div key={"table"}>
        {loading ? (
          <Loading />
        ) : tableDataResult?.length ? (
          <Report83Table tableData={tableDataResult} />
        ) : (
          <p>
            Ой, кажется, нет статистики за указанный период! Попробуйте изменить
            период!{" "}
          </p>
        )}
      </div>
    </div>
  );
}
